// src/utils/handleWordType.js
import testCltr from './testCltr';
import testAcc from './testAcc';

export default function handleWordType(
  e, para, time, setWord, setChrIndex, setMstk, setCPM, setWPM, setspScore, setMisPenal, setPoints, maxTime, timer, setTime, chrIndex, totalChars, totalCorrChars, setAcc) {
  const { value } = e.target;
  if (time <= 0 || value.length > para.length) return;
  setWord(value);
  setChrIndex(value.length);
  const { mstks, CPM, WPM, speedScore, mistakePenalty, totalPoints } = testCltr(para, value, time, (totalCorrChars.current / totalChars.current) * 100);
  setMstk(mstks);
  setCPM(CPM);
  setWPM(WPM);
  testAcc(value, para, chrIndex, totalChars, totalCorrChars, setAcc);
  setspScore(speedScore);
  setMisPenal(mistakePenalty);
  setPoints(totalPoints);

  if (!timer.current && time > 0) {
    timer.current = setTimeout(() => setTime(t => t - 1), 1000);
  }
}
